import { admin2 } from './instance'

// admin.keeperTypeSet.getExample
export const GetKeeperVehicleModelUploadExample = async ({
  shopId,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/keeperTypeSet/example`,
  })
}

// admin.keeperTypeSet.upload
export const UploadKeeperVehicleModel = async ({
  shopId,
  fileName,
  rawCsv,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/keeperTypeSet/upload`,
    data: {
      fileName,
      rawCsv,
    },
  })
}

// admin.keeperTypeSet.findAll
export const GetKeeperVehicleModelList = async ({
  shopId,
  start,
  limit,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/keeperTypeSet`,
    params: {
      start,
      limit,
    },
  })
}

// admin.keeperTypeSet.count
export const GetKeeperVehicleModelCount = async ({
  shopId,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/keeperTypeSet/count`,
  })
}

// admin.keeperTypeSet.getLatest
export const GetKeeperVehicleModelLatest = async ({
  shopId,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/keeperTypeSet/latest`,
  })
}

// admin.keeperVehicle.getTypeSet
export const GetKeeperVehicleTypeSet = async ({
  shopId,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/keeperVehicle/getTypeSet`,
  })
}

// admin.keeperVehicle.findAll
export const GetKeeperVehicleList = async ({
  shopId,
  start,
  limit,
  plate,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/keeperVehicle`,
    params: {
      start,
      limit,
      plate,
    },
  })
}

// admin.keeperVehicle.findOneByCode
export const FindKeeperVehicleByCode = async ({
  shopId,
  code,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/keeperVehicle/findOneByCode/${code}`,
  })
}

// admin.keeperVehicle.create
export const CreateKeeperVehicle = async ({
  shopId,
  plate,
  brandCode,
  typeCode,
  size,
  info,
  bindingMemberIds,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/keeperVehicle`,
    data: {
      plate,
      brandCode,
      typeCode,
      size,
      info,
      bindingMemberIds,
    },
  })
}

// admin.keeperVehicle.update
export const UpdateKeeperVehicle = async ({
  shopId,
  vehicleId,
  plate,
  brandCode,
  typeCode,
  size,
  info,
  addBindingMemberIds,
}) => {
  return admin2({
    method: 'PUT',
    url: `/${shopId}/keeperVehicle/${vehicleId}`,
    data: {
      plate,
      brandCode,
      typeCode,
      size,
      info,
      addBindingMemberIds,
    },
  })
}

// admin.keeperVehicle.bindMember
export const BindMemberKeeperVehicle = async ({
  shopId,
  vehicleId,
  memberId,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/keeperVehicle/bindMember`,
    data: {
      vehicleId,
      memberId,
    },
  })
}

// admin.keeperVehicle.unbindMember
export const UnbindMemberKeeperVehicle = async ({
  shopId,
  vehicleId,
  memberId,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/keeperVehicle/unbindMember`,
    data: {
      vehicleId,
      memberId,
    },
  })
}

// admin.keeperVehicle.count
export const GetKeeperVehicleCount = async ({
  shopId,
  plate,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/keeperVehicle/count`,
    params: {
      plate,
    },
  })
}

// admin.keeperVehicle.findAllByMember
export const GetKeeperVehicleListByMember = async ({
  shopId,
  memberId,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/keeperVehicle/findAllByMember/${memberId}`,
  })
}

// admin.keeperVehicle.findByPlate
export const CheckPlateAvailability = async ({
  shopId,
  plate,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/keeperVehicle/findByPlate`,
    params: {
      plate,
    },
  })
}
